// Hide language swicher or subdomain blog page. 
if (window.parent) {
    try {
        // Get the parent URL
        var parentURL = window.parent.location.href;
        // Check if the parent URL is the subdomain blog page
        if (parentURL.includes('/blog')) {
            // Hide all elements with the class 'lang-bar dropdown'
            document.querySelectorAll('.lang-bar.dropdown').forEach(function(element) {
                element.style.display = 'none';
            });
        }
    } catch (e) {
        console.warn("Unable to access parent location:", e); // Log the error for debugging
    }
}

/* Add toggle for mobile nav */
document.addEventListener('DOMContentLoaded', function() {
    let mobileNavToggle = document.querySelector('.menu-toggle');

    if (mobileNavToggle) {
        mobileNavToggle.addEventListener('click', function() {
            document.documentElement.classList.toggle('mobile-nav-opened');
            this.classList.toggle('opened');
        });
    }

    /* Dropdown toggle */

    let dropdowns = document.querySelectorAll('.dropdown .dropdown-toggle');

    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', function() {
            var dropdown = this.closest('.dropdown');
            dropdown.classList.toggle('show');
        });
    });

    let dropdownLinks = document.querySelectorAll('.dropdown .dropdown-menu a');

    dropdownLinks.forEach(link => {
        link.addEventListener('click', function() {
            var dropdown = this.closest('.dropdown');
            dropdown.classList.remove('show');
        });
    });

    let dropdown = document.querySelectorAll('.dropdown');

    document.addEventListener("click", function(event) {
        dropdown.forEach(function(dropdown) {
            if (!dropdown.contains(event.target)) {
                dropdown.classList.remove("show");
            }
        });
    });

    window.addEventListener("scroll", function() {
        dropdown.forEach(function(dropdown) {
            dropdown.classList.remove("show");
        });
    });

    /* /Dropdown toggle */

    /* Show content overlay when header dropdown showing up */

    let headerDropdown = document.querySelectorAll('#primary-menu-list li.menu-item-has-children');

    headerDropdown.forEach(function(dropdown) {
        let isDropdownOpen = false;
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
        const overlayContent = document.querySelector('.content-overlay');
        let lastClickedElement = null;

        dropdown.addEventListener('mouseleave', function() {
            if (window.innerWidth > 991) {
                if (overlayContent) {
                    overlayContent.classList.remove('show');
                }
                if (dropdownMenu) {
                    dropdownMenu.style.display = 'none';
                }
                isDropdownOpen = false;
                lastClickedElement = null;
            }
        });

        dropdown.addEventListener('click', function(event) {
            if (window.innerWidth > 991) {
                const clickedElement = event.target;

                // Check if the clicked element is a link within the dropdown
                if (clickedElement.tagName === 'A') {
                    // Check if link should open in new tab
                    if (clickedElement.classList.contains('open-new-tab')) {
                        event.preventDefault();
                        window.open(clickedElement.href, '_blank');
                        return;
                    }
                    
                    // If it's in dropdown menu, handle normal link click
                    if (dropdownMenu.contains(clickedElement)) {
                        window.location.href = clickedElement.href;
                        return;
                    }
                }

                event.preventDefault(); // Prevent default link behavior for parent

                if (!isDropdownOpen || lastClickedElement !== clickedElement) {
                    if (dropdownMenu) {
                        dropdownMenu.style.display = 'block';
                    }
                    if (overlayContent) {
                        overlayContent.classList.add('show');
                    }
                    isDropdownOpen = true;
                    lastClickedElement = clickedElement;
                } else {
                    if (overlayContent) {
                        overlayContent.classList.remove('show');
                    }
                    // Check if parent link should open in new tab
                    const parentLink = dropdown.querySelector('a');
                    if (parentLink && parentLink.classList.contains('open-new-tab')) {
                        window.open(parentLink.href, '_blank');
                    } else {
                        window.location.href = parentLink.href;
                    }
                }
            }
        });
    });

    /*  Check if window view less than 992px and make toggle for menu-item-has-children add class show */

    function toggleMenuItems() {
        var menuItems = document.querySelectorAll('#primary-menu-list li.menu-item-has-children');

        menuItems.forEach(function(item) {
            item.removeEventListener('click', toggleItem);
        });

        if (window.innerWidth < 992) {
            menuItems.forEach(function(item) {
                item.addEventListener('click', toggleItem);
            });
        }
    }

    // Modify the toggleItem function to handle first-level links
    function toggleItem(event) {
        // Get the clicked element
        const clickedElement = event.target;
        
        // If clicked element is a link
        if (clickedElement.tagName === 'A') {
            // Check if it's a first-level link with open-new-tab class
            if (clickedElement.classList.contains('open-new-tab')) {
                event.preventDefault();
                window.open(clickedElement.href, '_blank');
                return;
            }
            
            // If it's a regular link in dropdown, let the default behavior happen
            if (clickedElement.closest('.dropdown-menu')) {
                return;
            }
        }
        
        // Toggle dropdown for menu items with children
        this.classList.toggle('show');
    }

    // Initial check
    toggleMenuItems();

    // Handle first-level menu items without children
    const firstLevelLinks = document.querySelectorAll('#primary-menu-list > li:not(.menu-item-has-children) > a');
    
    firstLevelLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            if (this.classList.contains('open-new-tab')) {
                event.preventDefault();
                window.open(this.href, '_blank');
            }
        });
    });
});
/* Add toggle for mobile nav */

//Languages
/**
 * WEGLOT & GTRANSLATE COMPATIBILITY FOR IFRAME LANGUAGE SWITCHING
 * 
 * This code ensures the Yii2 booking form iframe (from booking.alps2alps.com subdomain)
 * displays in the correct language by setting a cross-domain cookie.
 * 
 * How it works:
 * 1. Detects language from URL pathname (Weglot uses /fr/, /es/, etc.)
 * 2. Falls back to <html lang=""> attribute if no URL prefix
 * 3. Updates a2aData.language and sets cookie on .alps2alps.com domain
 * 4. Yii2 iframe widget (wp-widget.min.js) reads this cookie to load correct translation
 * 
 * Supported languages: en, fr, es, tr, ru, pt
 * Cookie: a2a_data = {"language":"fr","currency":"EUR","height":76}
 */
const a2aData = {
    language: 'en',
    currency: 'EUR' ,
    height: 76
};

/**
 * WEGLOT COMPATIBILITY: Detect language from URL pathname
 * Weglot uses URL-based language switching (e.g., /fr/, /es/, /tr/)
 */
function detectLanguageFromURL() {
    const pathname = window.location.pathname;
    // Check if URL starts with a language code (e.g., /fr/, /es/, /tr/)
    const langMatch = pathname.match(/^\/([a-z]{2})(\/|$)/i);
    
    if (langMatch) {
        const detectedLang = langMatch[1].toLowerCase();
        // Verify it's a supported language
        const supportedLangs = ['en', 'fr', 'es', 'tr', 'ru', 'pt'];
        if (supportedLangs.includes(detectedLang)) {
            return detectedLang;
        }
    }
    
    return null;
}

function getCurrentLanguage() {
    const supportedLangs = ['en', 'fr', 'es', 'tr', 'ru', 'pt'];
    const urlLang = detectLanguageFromURL();

    if (urlLang) {
        return urlLang;
    }

    if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
        const weglotLang = String(Weglot.getCurrentLang() || '').split('-')[0].toLowerCase();
        if (supportedLangs.includes(weglotLang)) {
            return weglotLang;
        }
    }

    const htmlLang = String(document.documentElement.lang || '').split('-')[0].toLowerCase();
    return supportedLangs.includes(htmlLang) ? htmlLang : 'en';
}

function updateButtonText() {
    // WEGLOT COMPATIBILITY: Prefer the translated URL before runtime language state.
    let lang = getCurrentLanguage();
    let languageLabel = '';
    let flagUrl = '';

    switch(lang) {
        case 'en':
            languageLabel = 'English';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/en.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/en-lang.svg';
            lang = 'en';
            break;
        case 'fr':
            languageLabel = 'Français';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/fr.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/fr-lang.svg';
            lang = 'fr';
            break;
        case 'tr':
            languageLabel = 'Türkçe';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/tr.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/tr-lang.svg';
            lang = 'tr';
            break;
        case 'ru':
            languageLabel = 'Русский';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/ru.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/ru-lang.svg';
            lang = 'ru';
            break;
        case 'pt':
            languageLabel = 'Português';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/pt.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/pt-lang.svg';
            lang = 'pt';
            break;
        case 'es':
            languageLabel = 'Español';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/es.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/es-lang.svg';
            lang = 'es';
            break;
        default:
            languageLabel = 'English';
            flagUrl = '/wp-content/plugins/gtranslate/flags/svg/en.svg';
            flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/en-lang.svg';
            lang = 'en';
            break;
    }

    // WEGLOT COMPATIBILITY: Update GTranslate UI elements only if they exist
    const currentLanguageEl = document.getElementById('currentLanguage');
    if (currentLanguageEl) {
        currentLanguageEl.innerHTML = '<img src="' + flagUrl + '" alt="' + languageLabel + ' Flag"> ' + languageLabel;
    }

    let savedCurrency = localStorage.getItem('selectedCurrency') || 'GBP';
    const currentLanguageMobileEl = document.getElementById('currentLanguageMobile');
    if (currentLanguageMobileEl) {
        currentLanguageMobileEl.innerHTML = '<span class="language-label">' + languageLabel + '</span><span class="language-code">' + savedCurrency + '</span><img src="' + flagUrlMobile + '" alt="' + languageLabel + ' Flag">'
    }

    document.querySelectorAll('#languageList li').forEach(function(li) {
        li.style.display = 'block';
    });

    document.querySelectorAll('.mobile-view .lang-bar .dropdown-menu ul li').forEach(function(li) {
        li.style.display = 'block';
    })

    let currentLangItem = document.querySelector('#languageList li[data-lang="' + lang + '"]');
    if (currentLangItem) {
        currentLangItem.style.display = 'none';
    }

    let currentLangItemMobile = document.querySelector('.mobile-view .lang-bar .dropdown-menu ul li[data-lang="' + lang + '"]');
    if (currentLangItemMobile) {
        currentLangItemMobile.style.display = 'none';
    }

    // CRITICAL: Always update a2aData cookie for iframe language communication
    // Read current cookie first to preserve other properties (e.g., currency)
    let cookieData = getCookieValue('a2a_data') || {};
    cookieData.language = lang;
    setLanguageCurrencyAuthCookie('a2a_data', cookieData, 'alps2alps.com', 365);
}

// WEGLOT COMPATIBILITY: Initialize language detection with retry mechanism
// Weglot might set the lang attribute after our script loads
function initializeLanguageDetection() {
    // Update immediately so the booking iframe receives the correct cookie.
    updateButtonText();
    
    // Retry after short delay in case Weglot hasn't initialized yet
    setTimeout(function() {
        updateButtonText();
    }, 500);
    
    // Final check after Weglot should be fully loaded
    setTimeout(function() {
        updateButtonText();
    }, 1500);
}

// Run initialization
initializeLanguageDetection();

// WEGLOT COMPATIBILITY: Watch for language changes on <html lang=""> attribute
// This works with both GTranslate and Weglot, as both update the lang attribute
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.attributeName === "lang") {
            updateButtonText();
        }
    });
});

observer.observe(document.documentElement, { attributes: true });

// WEGLOT COMPATIBILITY: Listen for Weglot-specific events
if (typeof Weglot !== 'undefined') {
    // Listen for Weglot's language switch event
    document.addEventListener('weglot.switchLanguage', function(event) {
        setTimeout(updateButtonText, 100); // Small delay to ensure lang attribute is updated
    });
    
    // Listen for Weglot initialization
    document.addEventListener('weglot.initialized', function() {
        updateButtonText();
    });
}

// WEGLOT COMPATIBILITY: Check for Weglot object periodically in case it loads later
let weglotCheckAttempts = 0;
const weglotCheckInterval = setInterval(function() {
    if (typeof Weglot !== 'undefined' && !window.weglotListenersAdded) {
        window.weglotListenersAdded = true;
        
        document.addEventListener('weglot.switchLanguage', function(event) {
            setTimeout(updateButtonText, 100);
        });
        
        clearInterval(weglotCheckInterval);
    }
    
    weglotCheckAttempts++;
    if (weglotCheckAttempts >= 10) { // Stop checking after 5 seconds
        clearInterval(weglotCheckInterval);
    }
}, 500);

//Currencies
// document.addEventListener('DOMContentLoaded', function() {
const languageOptions = document.querySelectorAll('.left-side .lang-bar .dropdown-menu ul li a.glink');
const languageOptionsMobile = document.querySelectorAll('.mobile-view .lang-bar .dropdown-menu ul li a');

languageOptions.forEach(option => {
    option.addEventListener('click', function(e) {
        // Read current cookie first to preserve other properties (e.g., currency)
        let cookieData = getCookieValue('a2a_data') || {};
        cookieData.language = this.getAttribute('data-gt-lang');
        setLanguageCurrencyAuthCookie('a2a_data', cookieData, 'alps2alps.com', 365);
    });
});

languageOptionsMobile.forEach(option => {
    option.addEventListener('click', function(e) {
        // Read current cookie first to preserve other properties (e.g., currency)
        let cookieData = getCookieValue('a2a_data') || {};
        cookieData.language = this.getAttribute('data-gt-lang');
        setLanguageCurrencyAuthCookie('a2a_data', cookieData, 'alps2alps.com', 365);
    });
});

// WEGLOT: Intercept language switcher clicks and update a2a_data cookie BEFORE navigation
// This runs on click, before the page redirects to the new language URL
function setupWeglotLanguageSwitcher() {
    // Find all Weglot language links (they have class like 'weglot-language-en', 'weglot-language-fr', etc.)
    const weglotLinks = document.querySelectorAll('a[class*="weglot-language-"]');
    
    if (weglotLinks.length > 0) {
        weglotLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                // Extract language code from the parent li element's data-l attribute
                const parentLi = this.closest('li[data-l]');
                if (parentLi) {
                    const newLang = parentLi.getAttribute('data-l');
                    
                    // Update a2a_data cookie with new language BEFORE navigation
                    let a2aData = getCookieValue('a2a_data') || {};
                    a2aData.language = newLang;
                    setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
                    
                    // Let the default navigation proceed (don't prevent default)
                }
            });
        });
    }
}

// Try to setup immediately
setupWeglotLanguageSwitcher();

// Also setup after DOM is fully loaded (in case Weglot loads asynchronously)
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(setupWeglotLanguageSwitcher, 500);
});

// Watch for Weglot switcher being added to DOM dynamically
const weglotObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
            // Check if any added nodes contain Weglot switcher
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) { // Element node
                    if (node.classList && (node.classList.contains('weglot-dropdown') || node.classList.contains('country-selector'))) {
                        setTimeout(setupWeglotLanguageSwitcher, 100);
                    }
                }
            });
        }
    });
});

// Observe the body for Weglot switcher being added
if (document.body) {
    weglotObserver.observe(document.body, { childList: true, subtree: true });
} else {
    document.addEventListener('DOMContentLoaded', function() {
        weglotObserver.observe(document.body, { childList: true, subtree: true });
    });
}

const currentCurrencyBtn = document.getElementById('currentCurrency');
const currentCurrencyBtnMobile = document.getElementById('currentCurrencyMobile');
const currencyOptions = document.querySelectorAll('.currency-option');
const currencyOptionsMobile = document.querySelectorAll('.mobile-view .currency-bar .dropdown-menu li a');

const savedCurrency = localStorage.getItem('selectedCurrency') || 'EUR';
const savedCurrencySymbol = localStorage.getItem('selectedCurrencySymbol') || '€';
updateCurrentCurrency(savedCurrency, savedCurrencySymbol);

currencyOptions.forEach(option => {
    option.addEventListener('click', function(e) {
        e.preventDefault();
        let selectedCurrency = this.getAttribute('data-currency');
        let selectedCurrencySymbol = this.getAttribute('data-currency-symbol');
        updateCurrentCurrency(selectedCurrency, selectedCurrencySymbol);
        localStorage.setItem('selectedCurrency', selectedCurrency);
        localStorage.setItem('selectedCurrencySymbol', selectedCurrencySymbol);
    });
});

currencyOptionsMobile.forEach(option => {
    option.addEventListener('click', function(e) {
        e.preventDefault();
        let selectedCurrency = this.getAttribute('data-currency');
        let selectedCurrencySymbol = this.getAttribute('data-currency-symbol');
        updateCurrentCurrency(selectedCurrency, selectedCurrencySymbol);
        localStorage.setItem('selectedCurrency', selectedCurrency);
        localStorage.setItem('selectedCurrencySymbol', selectedCurrencySymbol);
    });
});

function updatePricesOnCurrencySwitch(currency) {
    // Get all offer elements
    const offerElements = document.querySelectorAll('[data-last-minute-offer-id]');

    if (offerElements.length === 0) {
        return;
    }

    // Track which offers need API fallback (missing data attributes)
    const needsApiFallback = [];

    // Step 1: Try to update using data attributes (instant, no API call)
    offerElements.forEach((offerElement) => {
        const offerId = offerElement.getAttribute('data-last-minute-offer-id');
        
        // Get price data from data attributes based on currency
        const currencyLower = currency.toLowerCase();
        
        const newPrice = offerElement.getAttribute(`data-price-${currencyLower}`);
        const newPriceOld = offerElement.getAttribute(`data-price-old-${currencyLower}`);
        
        const priceOldElement = offerElement.querySelector('.switch-price-old');
        const priceElement = offerElement.querySelector('.switch-price');

        if (priceOldElement && priceElement) {
            // Check if we have the price data in attributes (handle "0" as valid, but not null/undefined/empty)
            const hasPrice = newPrice !== null && newPrice !== undefined && newPrice !== '';
            const hasPriceOld = newPriceOld !== null && newPriceOld !== undefined && newPriceOld !== '';
            
            if (hasPrice && hasPriceOld) {
                priceOldElement.textContent = `${newPriceOld} ${currency}`;
                priceElement.textContent = `${newPrice} ${currency}`;
            } else {
                // No data attribute, need API fallback
                if (!needsApiFallback.includes(offerId)) {
                    needsApiFallback.push(offerId);
                }
            }
        }
    });

    // Step 2: If some offers need API fallback, fetch them
    if (needsApiFallback.length > 0) {
        const ids = needsApiFallback.join(',');
        const size = needsApiFallback.length > 6 ? `&size=${needsApiFallback.length}` : '';
        const url = `${apiBaseUrl}/api/offers?id=${ids}${size}`;
        
        fetch(url)
            .then(response => response.json())
            .then(data => {
                const offers = data.data;
                if (!offers || !Array.isArray(offers)) {
                    return;
                }

                offers.forEach(offer => {
                    const offerElements = document.querySelectorAll(`[data-last-minute-offer-id="${offer.id}"]`);
                    
                    offerElements.forEach((offerElement) => {
                        const priceOldElement = offerElement.querySelector('.switch-price-old');
                        const priceElement = offerElement.querySelector('.switch-price');

                        if (priceOldElement && priceElement) {
                            let newPrice, newPriceOld;
                            if (currency === 'GBP') {
                                newPriceOld = offer.price_old_gbp;
                                newPrice = offer.price_gbp;
                            } else if (currency === 'USD') {
                                newPriceOld = offer.price_old_usd;
                                newPrice = offer.price_usd;
                            } else {
                                newPriceOld = offer.price_old;
                                newPrice = offer.price;
                            }
                            
                            if (newPrice !== undefined && newPrice !== null) {
                                priceOldElement.textContent = `${newPriceOld} ${currency}`;
                                priceElement.textContent = `${newPrice} ${currency}`;
                                
                                // Also store in data attributes for future switches
                                const currencyLower = currency.toLowerCase();
                                offerElement.setAttribute(`data-price-${currencyLower}`, newPrice);
                                offerElement.setAttribute(`data-price-old-${currencyLower}`, newPriceOld);
                            }
                        }
                    });
                });

                // Update Swiper instances
                try {
                    if (typeof window.swiperInstances !== 'undefined' && window.swiperInstances) {
                        window.swiperInstances.forEach(instance => instance.update());
                    }
                } catch (e) {
                    // swiperInstances not available yet
                }
            })
            .catch(error => {
                // Silently handle API errors
            });
    }

    // Update Swiper instances (for data-attribute updates)
    try {
        if (typeof window.swiperInstances !== 'undefined' && window.swiperInstances) {
            window.swiperInstances.forEach(instance => instance.update());
        }
    } catch (e) {
        // swiperInstances not available yet
    }
}

function updateCurrentCurrency(currency, symbol) {
    // Update only the currency code span
    const currencyCodeElement = document.getElementById('currentCurrencyCode');
    if (currencyCodeElement) {
        currencyCodeElement.textContent = currency; // Update the currency code only
    }

    // Update mobile currency button
    const currentCurrencyBtnMobile = document.getElementById('currentCurrencyMobile');
    if (currentCurrencyBtnMobile) {
        const currencyCodeElement = currentCurrencyBtnMobile.querySelector('#currentCurrencyCode');
        if (currencyCodeElement) {
            currencyCodeElement.textContent = `${symbol} ${currency}`; // Update only the currency code and symbol
        }
    }

    // Update a2a_data cookie with selected currency
    // Read current cookie first to preserve other properties (e.g., language)
    let cookieData = getCookieValue('a2a_data') || {};
    cookieData.currency = currency;
    setLanguageCurrencyAuthCookie('a2a_data', cookieData, 'alps2alps.com', 365);

    // Hide selected currency from dropdown, show all others
    currencyOptions.forEach(option => {
        const listItem = option.closest('li');
        if (option.getAttribute('data-currency') === currency) {
            listItem.style.display = 'none';
        } else {
            listItem.style.display = 'block';
        }
    });

    currencyOptionsMobile.forEach(option => {
        const listItem = option.closest('li');
        if (option.getAttribute('data-currency') === currency) {
            listItem.style.display = 'none';
        } else {
            listItem.style.display = 'block';
        }
    });

    const languageCodeElement = document.querySelector('#currentLanguageMobile .language-code');
    if (languageCodeElement) {
        languageCodeElement.innerHTML = currency;
    }

    languageOptionsMobile.forEach(option => {
        let code = option.querySelector('.code');
        if (code) {
            code.textContent = ' - ' + currency;
        } else {
            const newCodeElement = document.createElement('span');
            newCodeElement.className = 'code';
            newCodeElement.textContent = ' - ' + currency;
            option.appendChild(newCodeElement);
        }
    });

    // Call new function to update prices
    updatePricesOnCurrencySwitch(currency);
    
    // CURRENCY INTEGRATION: Notify React app of currency change
    if (window.react && window.react.settings) {
        // Update React config immediately
        window.react.settings.currency_code = currency;
        window.react.settings.currency_char = symbol;
        
        // Dispatch event for React components to listen
        window.dispatchEvent(new CustomEvent('skiRentalCurrencyChanged', {
            detail: { 
                currency_code: currency, 
                currency_char: symbol,
                timestamp: Date.now(),
                source: 'header_selector'
            }
        }));
    }
    
    // 🚀 SHUTTLE INTEGRATION: Notify shuttle booking system of currency change
    window.dispatchEvent(new CustomEvent('shuttleCurrencyChanged', {
        detail: { 
            currency_code: currency, 
            currency_symbol: symbol,
            timestamp: Date.now(),
            source: 'header_selector'
        }
    }));
}
// });


//Setting cookies
function setLanguageCurrencyAuthCookie(name, jsonData, domain, days) {
    const value = JSON.stringify(jsonData); // Convert JSON object to a string
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // Older code also wrote a host-only copy (no domain); with both present, WP and ski-rental.alps2alps.com can read different values.
    if (location.hostname === domain || location.hostname.endsWith("." + domain)) {
        document.cookie = name + "=; max-age=0; path=/";
    }
    const secure = location.protocol === "https:" ? "; secure" : "";
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; domain=" + domain + "; path=/" + secure + "; samesite=Lax";
}

// //Getting cookie values
function getCookieValue(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '=([^;]+)');
    return match ? JSON.parse(decodeURIComponent(match[2])) : null;
}


// Function to fetch geoip data
function fetchGeoipData() {
    return new Promise((resolve, reject) => {
        fetch('/wp-admin/admin-ajax.php?action=get_geoip_data')
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    resolve(data.data); // Return the geoip data
                } else {
                    reject(data.data); // Handle error
                }
            })
            .catch(error => reject(error));
    });
}
// Initial currency setting for users based on geoip data
function setInitialCurrency() {
    if (!localStorage.getItem('initialCurrencySet')) {
        fetchGeoipData()
            .then(geoipData => {
                if (geoipData.countryIsoCode === 'GB') {
                    let a2aData = getCookieValue('a2a_data') || {};
                    a2aData.currency = 'GBP'; // Set currency to GBP
                    setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365); // Update the cookie
                    
                    // Set selectedCurrency and selectedCurrencySymbol to GBP
                    localStorage.setItem('selectedCurrency', 'GBP');
                    localStorage.setItem('selectedCurrencySymbol', '£'); // Assuming '£' is the symbol for GBP

                    // Call updateCurrentCurrency to update the switcher
                    updateCurrentCurrency(a2aData.currency, '£'); // Update the UI with GBP
                } else {
                    // If not from UK, set currency to EUR
                    let a2aData = getCookieValue('a2a_data') || {};
                    a2aData.currency = 'EUR'; // Set currency to EUR
                    setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365); // Update the cookie
                    
                    // Set selectedCurrency and selectedCurrencySymbol to EUR
                    localStorage.setItem('selectedCurrency', 'EUR');
                    localStorage.setItem('selectedCurrencySymbol', '€'); // Assuming '€' is the symbol for EUR

                    // Call updateCurrentCurrency to update the switcher
                    updateCurrentCurrency(a2aData.currency, '€'); // Update the UI with EUR
                }
                localStorage.setItem('initialCurrencySet', 'true'); // Mark that the initial currency has been set
            })
            .catch(error => {
                console.error('Error fetching geoip data:', error);
            });
    }
}

// Call to set initial currency
setInitialCurrency();

// CURRENCY INTEGRATION: Initialize currency sync with React app
document.addEventListener('DOMContentLoaded', function() {
    // Sync initial currency with React app after a small delay
    setTimeout(() => {
        const savedCurrency = localStorage.getItem('selectedCurrency') || 'EUR';
        const savedCurrencySymbol = localStorage.getItem('selectedCurrencySymbol') || '€';
        

        
        if (window.react && window.react.settings) {
            // Update React config with current currency
            window.react.settings.currency_code = savedCurrency;
            window.react.settings.currency_char = savedCurrencySymbol;
            
            // Dispatch initial currency event
            window.dispatchEvent(new CustomEvent('skiRentalCurrencyChanged', {
                detail: { 
                    currency_code: savedCurrency, 
                    currency_char: savedCurrencySymbol,
                    timestamp: Date.now(),
                    source: 'page_load_sync',
                    initial: true
                }
            }));
            

        } else {

        }
    }, 200); // Small delay to ensure React app is loaded
});


// Debounce your scroll handlers
// https://web.dev/articles/debounce-your-input-handlers#debounce_your_scroll_handlers

let lastScrollY = 0; // Initialize lastScrollY
let scheduledAnimationFrame = false; // Initialize scheduledAnimationFrame

function onScroll(evt) {
    // Store the scroll value for later use.
    lastScrollY = window.scrollY;

    // Prevent multiple rAF callbacks.
    if (scheduledAnimationFrame) return;

    scheduledAnimationFrame = true;
    requestAnimationFrame(readAndUpdatePage);
}

function readAndUpdatePage() {
    // Your logic to read and update the page goes here

    // Reset the flag after the frame is processed
    scheduledAnimationFrame = false;
}

window.addEventListener('scroll', onScroll);

// Store Swiper instances
const swiperInstances = [];

// Defer last-minute hero swiper initialization to prevent forced reflows
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var last_minute_grid_6_swipers = document.querySelectorAll(".last-minute-hero .grid-4-swiper .swiper");

        last_minute_grid_6_swipers.forEach(function(container) {
            if (container) {
                const swiperInstance = new Swiper(container, {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    loop: false,

                    navigation: {
                        nextEl: container.querySelector(".swiper-button-next"),
                        prevEl: container.querySelector(".swiper-button-prev"),
                    },

                    breakpoints: {
                        0: {
                            slidesPerView: 1.5,
                            spaceBetween: 16,
                        },
                        520: {
                            slidesPerView: 2.5,
                            spaceBetween: 16,
                        },
                        769: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                        992: {
                            slidesPerView: 4,
                        },
                    },
                });

                // Store the instance
                swiperInstances.push(swiperInstance);
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let consentBarInitialized = false;

    function initializeConsentBar() {
        // Must run once: a second click listener would toggle the text back immediately
        if (consentBarInitialized || !document.querySelector(".cky-consent-bar")) {
            return;
        }
        consentBarInitialized = true;

        const moreText = document.querySelector(".cky-notice-des > p:nth-of-type(2)");
        const button = document.querySelector(".cky-notice-des > p > a:not(.cky-policy)");

        // Define translations for "Read More" and "Read Less"
        const translations = {
            en: { readMore: "Read More", readLess: "Read Less" },
            fr: { readMore: "Lire la suite", readLess: "Lire moins" },
            tr: { readMore: "Devamını oku", readLess: "Daha az oku" },
            ru: { readMore: "Читать далее", readLess: "Читать меньше" },
            pt: { readMore: "Leia mais", readLess: "Leia menos" },
            es: { readMore: "Leer más", readLess: "Leer menos" }
        };

        // Get the language from the HTML tag
        const lang = document.documentElement.lang || 'en'; // Default to English if no lang attribute

        if (button) {
            button.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent the default anchor click behavior
                if (moreText.classList.contains("d-flex")) {
                    moreText.classList.remove("d-flex");
                    button.textContent = translations[lang]?.readMore || translations.en.readMore;
                } else {
                    moreText.classList.add("d-flex");
                    button.textContent = translations[lang]?.readLess || translations.en.readLess;
                }
            });
        }
    }

    // CookieYes is delayed until first interaction; it fires this event once the banner is rendered
    initializeConsentBar();
    document.addEventListener("cookieyes_banner_load", initializeConsentBar);
});

/* Hero Form Mobile Listener - iframe postMessage handler */

function initHeroFormMobileListener() {
    // Check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Get the form-col element
    let formCol = document.querySelector('.form-col');
    
    if (!formCol) {
        // Retry after a short delay in case DOM is still loading
        setTimeout(function() {
            formCol = document.querySelector('.form-col');
            if (!formCol) {
                return;
            }
            setupFormListener(formCol);
        }, 500);
        return;
    }
    
    setupFormListener(formCol);
}

function setupFormListener(formCol) {
    // Check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Find the .hero element (parent/ancestor of .form-col)
    const heroElement = formCol.closest('.hero');
    
    // Store original styles to restore later
    let originalStyles = {
        width: formCol.style.width,
        height: formCol.style.height,
        position: formCol.style.position,
        bottom: formCol.style.bottom,
        padding: formCol.style.padding,
        heroOverflow: heroElement ? heroElement.style.overflow : null,
        heroZIndex: heroElement ? heroElement.style.zIndex : null
    };
    
    // Going position:fixed pulls .form-col out of the hero's flex flow, so everything
    // after it (hero banners, the next section) jumps up and back again. The spacer holds
    // that space open for as long as the panel is fixed, which keeps CLS at zero.
    let formColSpacer = null;

    function addFormColSpacer() {
        if (formColSpacer || !formCol.parentElement) {
            return;
        }

        const height = formCol.getBoundingClientRect().height;
        if (!height) {
            return;
        }

        const formColStyles = window.getComputedStyle(formCol);

        formColSpacer = document.createElement('div');
        formColSpacer.className = 'a2a-form-col-spacer';
        formColSpacer.setAttribute('aria-hidden', 'true');
        formColSpacer.style.setProperty('height', height + 'px', 'important');
        formColSpacer.style.setProperty('width', '100%', 'important');
        formColSpacer.style.setProperty('flex', '0 0 auto', 'important');
        formColSpacer.style.setProperty('order', formColStyles.order, 'important');
        formColSpacer.style.setProperty('margin', formColStyles.margin, 'important');
        formColSpacer.style.setProperty('pointer-events', 'none', 'important');

        formCol.parentElement.insertBefore(formColSpacer, formCol);
    }

    function removeFormColSpacer() {
        if (!formColSpacer) {
            return;
        }

        if (formColSpacer.parentElement) {
            formColSpacer.parentElement.removeChild(formColSpacer);
        }
        formColSpacer = null;
    }

    // Apply fullscreen mobile styles
    function applyMobileFullscreen() {
        // Apply overflow: visible and z-index to .hero element (ALL screen sizes)
        if (heroElement) {
            heroElement.style.overflow = 'visible';
            heroElement.style.zIndex = '9999999999';
        }
        
        // Apply .form-col fullscreen styles only on mobile
        if (!isMobile()) {
            return;
        }
        
        // Measure and reserve the space before the element leaves the flow
        addFormColSpacer();

        // Use inset: 40px 0 0 0 to leave top space (e.g. header) on mobile
        formCol.style.setProperty('position', 'fixed', 'important');
        formCol.style.setProperty('inset', '40px 0px 0px 0px', 'important');
        formCol.style.setProperty('width', '100%', 'important');
        formCol.style.setProperty('height', '100%', 'important');
        formCol.style.setProperty('padding', '0', 'important');
        formCol.style.setProperty('background-color', '#fff', 'important');
        formCol.style.setProperty('z-index', '9999', 'important');
        formCol.style.setProperty('overflow', 'auto', 'important');
        
        // Set min-height on widget wrapper (mobile only)
        if (typeof jQuery !== 'undefined') {
            jQuery('#a2a-widget-wrapper #a2a-widget').css('min-height', '100dvh');
        } else {
            const widgetElement = document.querySelector('#a2a-widget-wrapper #a2a-widget');
            if (widgetElement) {
                widgetElement.style.minHeight = '100dvh';
            }
        }
    }
    
    // Remove fullscreen mobile styles
    function removeMobileFullscreen() {
        // Restore overflow and z-index on .hero element (ALL screen sizes)
        if (heroElement) {
            heroElement.style.overflow = originalStyles.heroOverflow || 'hidden';
            if (originalStyles.heroZIndex) {
                heroElement.style.zIndex = originalStyles.heroZIndex;
            } else {
                heroElement.style.removeProperty('z-index');
            }
        }
        
        // Remove .form-col fullscreen styles only on mobile
        if (!isMobile()) {
            removeFormColSpacer();
            return;
        }
        
        formCol.style.width = originalStyles.width;
        formCol.style.height = originalStyles.height;
        formCol.style.position = originalStyles.position;
        formCol.style.bottom = originalStyles.bottom;
        formCol.style.padding = originalStyles.padding;
        formCol.style.removeProperty('inset');
        formCol.style.removeProperty('background-color');
        formCol.style.removeProperty('z-index');
        formCol.style.removeProperty('overflow');
        formCol.style.removeProperty('top');
        formCol.style.removeProperty('-webkit-overflow-scrolling');
        
        // Reset min-height on widget wrapper (mobile only)
        if (typeof jQuery !== 'undefined') {
            jQuery('#a2a-widget-wrapper #a2a-widget').css('min-height', '520px');
        } else {
            const widgetElement = document.querySelector('#a2a-widget-wrapper #a2a-widget');
            if (widgetElement) {
                widgetElement.style.minHeight = '520px';
            }
        }

        // Released last so the form is back in the flow before the space is given up
        removeFormColSpacer();
    }
    
    // Older embeds can report a panel closing right after another one opened (the incoming
    // panel fires its show event before the outgoing one fires hide), which would strip the
    // hero styles while a panel is still visible. Deferring the close lets that open cancel it.
    let heroCloseTimer = null;
    
    // Listen for postMessage events from iframe
    window.addEventListener('message', function(e) {
        // Check if message has action property
        if (e.data && e.data.hasOwnProperty('action')) {
            switch (e.data.action) {
                case 'open-panel':
                    clearTimeout(heroCloseTimer);
                    heroCloseTimer = null;
                    applyMobileFullscreen();
                    break;
                    
                case 'close-panel':
                    clearTimeout(heroCloseTimer);
                    heroCloseTimer = setTimeout(function() {
                        heroCloseTimer = null;
                        removeMobileFullscreen();
                    }, 60);
                    break;
            }
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroFormMobileListener);
} else {
    initHeroFormMobileListener();
}